(function () {
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    localStorage.setItem(name, value);
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return localStorage.getItem(name) || null;
  }

  function setDogIDCookie(value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
    document.cookie = "dog_id=" + (value || "") + expires + "; path=/";
    localStorage.setItem("dog_id", value);
  }

  function setCampaignCookie(value) {
    if (!value) {
      return;
    }

    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
    document.cookie = "campaign=" + (value || "") + expires + "; path=/";
    localStorage.setItem("campaign", value);
  }

  function getCampaignCookie() {
    var campaignFromLocalStorage = localStorage.getItem("campaign");
    if (campaignFromLocalStorage) {
      return campaignFromLocalStorage;
    }

    return getCookie("campaign");
  }

  function getDogIDCookie() {
    return getCookie("dog_id");
  }

  window.setCookie = setCookie;
  window.getCookie = getCookie;
  window.setDogIDCookie = setDogIDCookie;
  window.setCampaignCookie = setCampaignCookie;
  window.getCampaignCookie = getCampaignCookie;
  window.getDogIDCookie = getDogIDCookie;
})();
